import React from 'react'
import styles from './UIGameVoteActions.module.scss'
import {PlayerColor} from '@colonist/game-states'
import {Button, T} from '@colonist/ui'
import clsx from 'clsx'
import {useGameStore} from '../../../store/GameStoreContext'

export interface UIGameVoteParticipantsProps {
    acceptedVotes: PlayerColor[]
    declinedVotes: PlayerColor[]
    onAccept: () => void
    onDecline: () => void
}

export const UIGameVoteActions = ({acceptedVotes, declinedVotes, onAccept, onDecline}: UIGameVoteParticipantsProps) => {
    const myColor = useGameStore((state) => state.myColor)
    const isMyColorAccepted = acceptedVotes.includes(myColor)
    const isMyColorDeclined = declinedVotes.includes(myColor)
    const isMyColorVoted = isMyColorAccepted || isMyColorDeclined

    return (
        <div className={styles.actionsContainer}>
            <Button
                onClick={onDecline}
                className={clsx(styles.button, {[styles.passivelyActive]: isMyColorDeclined})}
                disabled={isMyColorVoted}
                variant='outline'
            >
                <T id='strings:colonistCommon.buttons.decline' />
            </Button>
            <Button
                onClick={onAccept}
                className={clsx(styles.button, {[styles.passivelyActive]: isMyColorAccepted})}
                disabled={isMyColorVoted}
                variant='outline'
            >
                <T id='strings:colonistCommon.buttons.accept' />
            </Button>
        </div>
    )
}
